import { render, staticRenderFns } from "./ZyroBlockPreview.vue?vue&type=template&id=5420b8e8&scoped=true&"
import script from "./ZyroBlockPreview.vue?vue&type=script&lang=js&"
export * from "./ZyroBlockPreview.vue?vue&type=script&lang=js&"
import style0 from "./ZyroBlockPreview.vue?vue&type=style&index=0&id=5420b8e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5420b8e8",
  null
  
)

export default component.exports